module.exports = __webpack_public_path__ + "static/media/addCompanyLogo.a720c70e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/images/addCompanyLogo.svg
// module id = 7751
// module chunks = 0